import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { MailSecurityInfoDetail, MailSecurityInfoResponse, MailSecurityUpdateKeyDetail } from '@/types/emailSerurity';
import { getMailSecurityInfo } from '@/api/accountEndpoint';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

type MailSecurityState = {
    mailSecurity?: MailSecurityInfoDetail|undefined;
    mailSecurityUpdateInfo?: MailSecurityUpdateKeyDetail|undefined;
    loading: boolean;
    mailSecurityCommonLayout: boolean;
};

const mailSecurityUpdateInfo = 'mailSecurityUpdateInfo';

const mailSecurityModule: Module<MailSecurityState, RootState> = {
    namespaced: true,
    state: {
        mailSecurity: undefined,
        mailSecurityUpdateInfo: undefined,
        mailSecurityCommonLayout: false,
        loading: false
    },
    getters: {
        mailSecurity(state): MailSecurityInfoDetail|undefined {
            return state?.mailSecurity;
        },
        mailSecurityUpdateInfo(state): MailSecurityUpdateKeyDetail|undefined {
            return state?.mailSecurityUpdateInfo;
        },
        mailSecurityCommonLayout(state): boolean {
            return !!state?.mailSecurityCommonLayout;
        },
        isLoading(state): boolean {
            return state.loading;
        },
        isFirstLogin(state): boolean {
            return !!state.mailSecurity?.isFirstLogin;
        }
    },
    mutations: {
        set(state, value: MailSecurityState) {
            Object.assign(state, value);
        },
        setMailSecurity(state, value: MailSecurityInfoDetail) {
            state.mailSecurity = value;
        },
        setMailSecurityUpdateInfo(state, value: MailSecurityUpdateKeyDetail) {
            localStorage.setItem(mailSecurityUpdateInfo, JSON.stringify(value));
            state.mailSecurityUpdateInfo = value;
        },
        setMailSecurityCommonLayout(state, value: boolean) {
            state.mailSecurityCommonLayout = value;
        },
        setLoading(state, loading: boolean) {
            state.loading = loading;
        }
    },
    actions: {
        async receive({ commit, getters }, force = false) {
            if (getters.mailSecurity && !force) return;
            const promise = new Promise((resolve) => {
                commit('setLoading', true);
                getMailSecurityInfo()
                    .then(res => {
                        commit('setMailSecurity', res.detail as MailSecurityInfoResponse);
                        resolve(res);
                    })
                    .catch(error => {
                        console.error('Error fetching MailSecurityInfoDetail:', error);
                        resolve(undefined);
                    })
                    .finally(() => {
                        commit('setLoading', false);
                    });
            });
            return promise;
        },
        receiveMailSecurityUpdate({ commit, getters }) {
            if(getters.mailSecurityUpdateInfo) return;
            const info = localStorage.getItem(mailSecurityUpdateInfo);
            if (info) {
                try {
                    const parsedInfo = JSON.parse(info);
                    commit('setMailSecurityUpdateInfo', parsedInfo);
                } catch (e) {
                    commit('setMailSecurityUpdateInfo', undefined);
                }
            }
        },
        clear({ commit }) {
            commit('setMailSecurity', undefined);
            commit('setMailSecurityUpdateInfo', undefined);
            commit('setMailSecurityCommonLayout', false);
            commit('setLoading', false);
            localStorage.removeItem(mailSecurityUpdateInfo);
        },
        clearHomePopupDismissed() {
            sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.MAIL_SECURITY_HOME_POPUP_DISMISSED);
        }
    },
};

export default mailSecurityModule;